"use strict";

angular.module("core")
.directive("confirmPassword", function(ModalService) {
    return {
        restrict: "A",
        scope: {
            scopeName: "@confirmPasswordScopeName",
        },
        link: function(scope) {
            var sharedScope = scope.$new();
            var scopeName = scope.scopeName;

            scope.$on("confirmPassword" + scopeName, function() {
                ModalService.showModal({
                    templateUrl: require("./confirm-password.modal.html"),
                    controller: "ConfirmPasswordModalController",
                    controllerAs: "confirmPasswordModalCtrl",
                    inputs: {
                        $attrs: {
                            sharedScope: sharedScope,
                            scopeName: scopeName
                        }
                    }
                }).then(function(modal) {
                    modal.element.modal();
                    modal.element.on("hidden.bs.modal", function() {
                        modal.element.remove();
                    });
                });
            })
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/confirm-password/confirm-password.directive.js
// module id = 510
// module chunks = 0